import { Table } from "antd";
import { UNITS } from "components/Common/Constants";
import NoData from "components/Common/NoData";

const ConnectivityStatisticsTable = ({
  tableData,
}) => {

  const columns = [
    {
      title: "Model Name",
      dataIndex: "vehicleModelName",
      key: "vehicleModelName",
      className: "pl1",
    },
    {
      title: "TCU",
      dataIndex: "avgTcuAvailabilityPercentage",
      key: "avgTcuAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Battery",
      dataIndex: "avgBatteryAvailabilityPercentage",
      key: "avgBatteryAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Accelerometer",
      dataIndex: "avgAccelerometerAvailabilityPercentage",
      key: "avgAccelerometerAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Analog",
      dataIndex: "avgAnalogAvailabilityPercentage",
      key: "avgAnalogAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Location",
      dataIndex: "avgLocationAvailabilityPercentage",
      key: "avgLocationAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
    {
      title: "Motor",
      dataIndex: "avgMotorAvailabilityPercentage",
      key: "avgMotorAvailabilityPercentage",
      align: "center",
      className: "plr05",
      render: (avgTcuAvailabilityPercentage) => `${avgTcuAvailabilityPercentage || 0} ${UNITS.PERCENT}`,
    },
  ];

  return tableData?.length > 0 ? (
    <Table
      data-testid="eol-heart-beat-table"
      columns={columns}
      dataSource={tableData}
      rowKey={(record) => record.vehicleModelName}
      scroll={{ x: "100%" }}
      pagination={false}
      className="eol-dyno-statistics-table"
    />
  ) : (
    <div className="pd3025" data-testid="empty-eol-heart-beat-statistics-table">
      <NoData />
    </div>
  );
};
export default ConnectivityStatisticsTable;